/**
 * Skip Audio button configuration.
 *
 * Controls how long (in seconds) audio must play before the "Skip Audio" button
 * becomes clickable. Users can skip long/stuck audio playback after this delay.
 *
 * Set SKIP_AUDIO_THRESHOLD_SECONDS to change when the button appears:
 *   - 0: Skip button available immediately
 *   - 1: Skip button after 1 second (default)
 *   - 10: Skip button after 10 seconds
 *
 * Valid range: 0–60 seconds.
 */
export const SKIP_AUDIO_THRESHOLD_SECONDS = 1;
